module.exports = __webpack_public_path__ + "static/media/facebook.385dd73b.svg";